import { getAvailabilityConfig } from "../../helpers/products/availability";

export const parseCartMessage = (datum) => {
    if (!datum) return null;

    if (typeof datum.get !== "function") {
        return {
            text: datum.text,
            variant: datum.variant,
        };
    }

    return {
        text: datum.get("text"),
        variant: datum.get("variant"),
    };
};

export const parseCartItem = (datum) => {
    if (!datum) return null;

    if (typeof datum.get !== "function") {
        return {
            id: datum.id,
            title: datum.title,
            price: Number(datum.price) || 0,
            image: datum.image,
            quantity: Number(datum.quantity) || 0,
            code: datum.code,
            availabilityLabel: getAvailabilityConfig(datum.availabilityLabel),
        };
    }

    return {
        id: datum.get("id"),
        title: datum.get("title"),
        price: Number(datum.get("price")) || 0,
        image: datum.get("image"),
        quantity: Number(datum.get("quantity")) || 0,
        code: datum.get("code"),
        availabilityLabel: getAvailabilityConfig(datum.get("availabilityLabel")),
    };
};

export const parseCartItems = (items) => {
    if (!items) return [];

    if (typeof items.toJS !== "function" && Array.isArray(items)) {
        return items.map(parseCartItem).filter(Boolean);
    }

    return items.map((item) => parseCartItem(item)).filter(Boolean).toArray();
};

export const parseSimpleOption = (datum) => {
    if (!datum) return null;

    if (typeof datum.get !== "function") {
        return {
            id: datum.id || "",
            name: datum.name || datum.Description || "",
            Description: datum.Description || datum.name || "",

            Address: datum.Address || datum.address || "",
            ZipCode: datum.ZipCode || datum.zipcode || "",
            City: datum.City || datum.city || "",
            Region: datum.Region || datum.region || "",
            AddrPhone: datum.AddrPhone || datum.phone || "",
            CountryId: datum.CountryId || "",

            address: datum.address || datum.Address || "",
            zipcode: datum.zipcode || datum.ZipCode || "",
            city: datum.city || datum.City || "",
            phone: datum.phone || datum.AddrPhone || "",
        };
    }

    return {
        id: datum.get("id") || "",
        name: datum.get("name") || datum.get("Description") || "",
        Description: datum.get("Description") || datum.get("name") || "",

        Address: datum.get("Address") || datum.get("address") || "",
        ZipCode: datum.get("ZipCode") || datum.get("zipcode") || "",
        City: datum.get("City") || datum.get("city") || "",
        Region: datum.get("Region") || datum.get("region") || "",
        AddrPhone: datum.get("AddrPhone") || datum.get("phone") || "",
        CountryId: datum.get("CountryId") || "",

        address: datum.get("address") || datum.get("Address") || "",
        zipcode: datum.get("zipcode") || datum.get("ZipCode") || "",
        city: datum.get("city") || datum.get("City") || "",
        phone: datum.get("phone") || datum.get("AddrPhone") || "",
    };
};

export const parseSimpleOptions = (items) => {
    if (!items) return [];

    if (typeof items.toJS !== "function" && Array.isArray(items)) {
        return items.map(parseSimpleOption).filter(Boolean);
    }

    return items.map((item) => parseSimpleOption(item)).filter(Boolean).toArray();
};